var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"idle-overtime\" ng-show=\"disconnect\"\u003E \u003Cspan\u003E&#9888; \u003Ci\u003EDisconnected due to 5 minutes idle, please refresh\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cvideo tabindex=\"1\" disconnect=\"disconnect\"\u003E\u003Cdiv class=\"loading\"\u003E \u003Ci class=\"fa fa-spinner fa-spin\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fvideo\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/component/device/remote/directive/remote-desktop.pug
// module id = 427
// module chunks = 0